const images = {
  blast: require('./blastImage.png'),
};

export default images;
